// llmNode.js

import { BaseNode } from './BaseNode';
import { Position } from 'reactflow';

export const LLMNode = ({ id, data }) => {
  const handles = [
    {
      type: 'target',
      position: Position.Left,
      id: `${id}-system`,
      style: { top: `${100 / 3}%`, left: '-2px' }
    },
    {
      type: 'target',
      position: Position.Left,
      id: `${id}-prompt`,
      style: { top: `${200 / 3}%`, left: '-2px' }
    },
    {
      type: 'source',
      position: Position.Right,
      id: `${id}-response`,
      style: { right: '-2px' }
    }
  ];

  return (
    <BaseNode
      id={id}
      data={data}
      type="llm"
      title="LLM"
      handles={handles}
      style={{ height: 100 }}
    >
      <div>
        <span>This is a LLM.</span>
      </div>
    </BaseNode>
  );
};
